export default [
    'return-announced',
    'return-received',
    'return-scan-in-process',
]
